import EditReperto from './EditReperto';
export default EditReperto;